import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getListHopDongChoDuyet,
  updateDataSearch,
} from "../../../../actions/DanhSachHopDongChoDuyet";
import { ModalSearchNangCaoMobile } from "./ModalSearchNangCaoMobile";

export const SearchBarMobile = ({}) => {
  const dispatch = useDispatch();

  const dataSearch = useSelector((state) => state.dataSearchHopDongChoDuyet);

  const updateState = (field, text) => {
    dispatch(
      updateDataSearch({
        ...dataSearch,
        [field]: text,
        pageIndex: 1,
      })
    );
  };

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const onSearch = () => {
    dispatch(getListHopDongChoDuyet(dataSearch));
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      dispatch(
        updateDataSearch({
          ...dataSearch,
          pageIndex: event,
        })
      );
      dispatch(getListHopDongChoDuyet(dataSearch));
    }
  }; //sự kiện tìm kiếm enter

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <div className="repeater-default hide-table-main show-mobile-main hidden-des-main">
        <div data-repeater-list="car">
          <div data-repeater-item className="">
            <form className="search-full form row bg-search-form form-mobile-search">
              <div
                className="text-right  search-p mb-1  "
                style={{ width: "100%" }}
              >
                <div className="form-search-mobile-new">
                  <div className="left-search-mobile-new">
                    <div className="search-mobile-new">
                      <fieldset className="form-group position-relative mb-0">
                        <input
                          className="form-control input-sm"
                          placeholder="Tên, SĐT, CCCD khách hàng"
                          value={dataSearch.customerName}
                          onChange={updateTextValue("customerName")}
                          onKeyDown={handleKeyDown}
                        />
                        <div
                          className="form-control-position"
                          onClick={onSearch}
                        >
                          <i className="mdi mdi-magnify"></i>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                  <div className="right-search-mobile-new">
                    <div class="icon-search-mobile">
                      <a
                        href={() => false}
                        className="card-link blue darken-2 text-search-new"
                        onClick={handleShow}
                      >
                        <i className="mdi mdi-filter"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        {show && <ModalSearchNangCaoMobile show={show} onHide={handleClose} />}
      </div>
    </>
  );
};
